import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

export default function Toast() {

    return (
        <ToastContainer 
            position='top-right'
            autoClose={5000}
            draggable
        />
    );
}


    //   <ToastContainer
    //     position="bottom-center" // Customize position as needed
    //     autoClose={5000} // Auto close after 5 seconds
    //     hideProgressBar={false}
    //     newestOnTop={false}
    //     closeOnClick
    //     rtl={false}
    //     pauseOnFocusLoss
    //     draggable
    //     pauseOnHover
    //     theme="colored" // Or 'light', 'dark'
    //   />